<template>
  <form class="forgot-password-form" @submit.prevent="formSubmitted">
    <h1 class="mb-2">Forgot your password?</h1>
    <p class="mb-2">No problem, we can help.<br/>Provide your email address to request instructions.</p>
    <lp-input v-model="email" label-top="Email" compact />
    <div class="ly-row mt-2 ly-even-2">
      <button @click="goBack" type="button"> Go Back</button>
      <lp-button :disabled="disableForm || props.isSubmitting" :loading="props.isSubmitting" type="primary" class="btn-loading-active">Send Instructions</lp-button>
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, defineEmits, computed, Ref, inject } from 'vue'
import { Redirect } from '@/types/redirect'

const redirect = inject('redirect') as Redirect
const props = defineProps(['isSubmitting'])
const email: Ref<string> = ref('')
const emit = defineEmits(['formSubmitted'])
const disableForm = computed(() => !email.value)

const formSubmitted = () => {
  window.localStorage.setItem('email', email.value)
  const provider = window.localStorage.getItem('provider') || 'LMS'
  email.value = email.value.trim()
  emit('formSubmitted', {
    email: email.value,
    provider
  })
}

const goBack = () => {
  redirect('LoginView')
}

</script>

<style>
.forgot-password-form {
  margin: 0px 0px;
  padding: 0px 0px;
}

.forgot-password-container h2 {
  font-size: 24px;
  font-weight: 400 !important;
  color: var(--primary);
}
</style>
